<template>
   <button class="offer-button" :class="buttonClass" @click="handleClick" v-if="AllowedAgencies">
      <Icon name="link-external-02" color="white" />

      <div class="offer-button-content">
         <span class="offer-title">paxlounge</span>
         <span v-if="showSubtitle" class="offer-subtitle">{{ subtitleText }}</span>
      </div>
   </button>
</template>

<script>
export default {
   name: "PaxConnectButton",
   props: {
      offerSuccess: {
         type: Boolean,
         default: false,
      },
      showSubtitle: {
         type: Boolean,
         default: false,
      },
      customClass: {
         type: String,
         default: "",
      },
   },
   computed: {
      AllowedAgencies() {
         const allowedAgencyIds = [1422, 1151, 130, 3];
         const agencyId = this.$store.state.user.user?.onBehalfOfs?.agencyOnBehalfOfId;

         return allowedAgencyIds.includes(agencyId);
      },
      buttonClass() {
         return {
            "offer-success": this.offerSuccess,
            [this.customClass]: this.customClass,
         };
      },
      subtitleText() {
         return this.offerSuccess ? this.$t("hotelBasket_lblConnected2App") : this.$t("hotelBasket_lblConnect2App");
      },
   },
   methods: {
      handleClick() {
         this.$emit("click");
      },
   },
};
</script>
